import React from 'react'
import { useState, useEffect } from 'react';

function Tab() {

    const [count, setCount] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    
    setCount(prevCount => prevCount + 1);
    
}, 500);


return () => clearInterval(interval);
}, []);

if(count % 4 === 0) {
    return(<title>▂▅▇ Welcome ▇▅▂</title>)
} else if(count % 4 === 1) {
    return(<title>▂▇▅ Welcome ▅▇▂</title>)
} else if(count % 4 === 2) {
    return(<title>▇▅▂ Welcome ▂▅▇</title>)
} else  if(count % 4 === 3) {
    return(<title>▅▇▂ Welcome ▅▇▂</title>)
}

}

export default Tab
